export default (lang: string) => lang.split('-')[0];
